// From Stack Overflow: https://stackoverflow.com/a/54096391/2333933

import { useEffect, useRef } from "react"
import isEqual from "react-fast-compare"

function deepCompareEquals(a, b) {
  return isEqual(a, b)
}

function useDeepCompareMemoize(value) {
  const ref = useRef()
  // it can be done by using useMemo as well
  // but useRef is rather cleaner and easier

  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}

function useDeepCompareEffect(callback, dependencies) {
  useEffect(callback, dependencies.map(useDeepCompareMemoize))
}

export default useDeepCompareEffect
